var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActionCustom = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "action-custom_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-1.208-.958h15v15h-15z"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.48 24.167C5.883 24.167.541 18.824.541 12.229.542 5.634 5.884.292 12.479.292s11.938 5.342 11.938 11.937-5.343 11.938-11.938 11.938z",
  opacity: "undefined",
  fill: "#F1C40F"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#action-custom_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m15.738 10.21-.734-1.705-1.773-.784 1.773-.768.734-1.62.733 1.62 1.773.768-1.773.784-.733 1.706zm0 10.147-.734-1.637-1.773-.767 1.773-.768.734-1.722.733 1.722 1.773.768-1.773.767-.733 1.637zM8.25 17.731l-1.569-3.36-3.427-1.534 3.427-1.535 1.57-3.342 1.585 3.342 3.41 1.535-3.41 1.535-1.586 3.36zm0-2.524.819-1.637 1.671-.733-1.671-.733-.819-1.638-.801 1.638-1.688.733 1.688.733.801 1.637z"
}))));
export { SvgActionCustom as ReactComponent };
export default __webpack_public_path__ + "images/action-custom.svg";